import React from 'react';
import ckLogoAsset from '../assets/ck-logo.png';

interface CkLogoProps {
  size?: number;
  className?: string;
  alt?: string;
}

export const CkLogo: React.FC<CkLogoProps> = ({
  size = 36,
  className = '',
  alt = 'CK Share Logo'
}) => {
  return (
    <div
      style={{ width: size, height: size }}
      className={`relative inline-flex items-center justify-center select-none flex-shrink-0 ${className}`}
    >
      <img
        src={ckLogoAsset}
        alt={alt}
        width={size}
        height={size}
        loading="eager"
        decoding="async"
        className="w-full h-full object-contain filter drop-shadow-[0_0_12px_rgba(0,240,255,0.3)] transition-all duration-300 pointer-events-none"
      />
    </div>
  );
};
